import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async createEmailVerificationResend ({ commit }, params) {      
      await platformAction({
        client: this.$api.profiles.accountVerificationEmails,
        method: 'create',
        commit,
        params,
        logError: this.$logError,
        commitData: false
      })
    }
  },
  getters: {
    ...platformGetters
  },
  mutations: {
    ...platformMutations
  }
}
